import styled from 'styled-components';

export const Line = styled.div`
  display: flex;
  width: 1px;
  height: 14px;
  margin: 4px 12px 2px;
  background-color: var(--primary-gray-divider);
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  svg {
    user-select: none;
  }
  @media (max-width: 1200px) {
    justify-self: center;
    width: 100%;
    flex-direction: column;
    gap: 16px;

    align-items: center;
    ${Line} {
      display: none;
    }
    background-color: var(--white);
    position: fixed;
    padding-top: 12px;
    padding-bottom: 12px;

    bottom: 0;

    svg {
      display: none;
    }
  }
`;

export const FooterText = styled.span`
  opacity: 0.67;
  font-size: 8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: var(--primary-gray);
`;

export const Auth = styled.div`
  display: flex;
  align-items: center;
`;

export const AuthText = styled.span`
  font-size: 10px;
  font-weight: 600;

  font-weight: bold;
  user-select: none;
  color: var(--black);
`;

export const SignOutButton = styled.button`
  margin-left: 4px;
  background-color: transparent;
  text-decoration: underline;
  border: none;
  font-size: 10px;
  font-weight: bold;
  color: var(--black);
  cursor: pointer;
  user-select: none;
`;
